import { Component, OnInit } from '@angular/core';
import { NouveauteService, ContextService } from '../shared';
import { ActivatedRoute, Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'app-nouveaute',
  templateUrl: './nouveaute.component.html',
  styleUrls: ['./nouveaute.component.scss']
})
export class NouveauteComponent implements OnInit {

  nouveautes: Array<string> = [];
  loading: boolean = true;
  context: string;
  context_route: string;
  constructor(
  	private nouveauteService: NouveauteService,
     private router: Router,
     private contextService: ContextService,
  ) {  window.scrollTo(0, 0);
  }

  ngOnInit() {

     this.context = this.contextService.getContext();
    this.context_route = (this.context == 'B2B')?'':'/familles';
     this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.context= (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.context_route=(this.context=='B2B')?'':'/familles'; 
        }
          
     });


  	this.nouveauteService.getAllNouveautes()
      .subscribe(nouveautes => {
        this.nouveautes = nouveautes;
        this.loading = false;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/nouveaute/nouveaute.component.ts